module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inbox-body"
  }, [(_vm.studentName) ? _c('div', {
    staticClass: "inbox-header"
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.studentName) + "\n\t\t\t"), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.className))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inbox-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('school-class-list', {
    attrs: {
      "with-students": true,
      "label": 'Turma:'
    }
  })], 1), _vm._v(" "), (_vm.className) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label"
  }, [_vm._v("Selecione o aluno:")]), _vm._v(" "), _c('students', {
    class: 'col-md-12',
    attrs: {
      "context": 'newmessage',
      "imglist": true
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.studentName) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label"
  }, [_vm._v("Responsável:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "responsibles"
    }
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "label": "name",
      "options": _vm.responsibles,
      "value": _vm.responsibles,
      "placeholder": "Selecione os responsáveis:"
    },
    model: {
      value: (_vm.responsible),
      callback: function($$v) {
        _vm.responsible = $$v
      },
      expression: "responsible"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.studentName) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label"
  }, [_vm._v("Membro da escola:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "schoolMembers"
    }
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "label": "formatedName",
      "options": _vm.schoolmembers,
      "value": _vm.schoolmembers,
      "placeholder": "Selecione os membros da escola:"
    },
    model: {
      value: (_vm.member),
      callback: function($$v) {
        _vm.member = $$v
      },
      expression: "member"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label"
  }, [_vm._v("Assunto:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subject),
      expression: "subject"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subject = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group emoji-text relative"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label"
  }, [_vm._v("Mensagem:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emojiPickerVisible),
      expression: "emojiPickerVisible"
    }],
    staticClass: "absolute",
    attrs: {
      "exclude": ['flags', 'symbols'],
      "i18n": _vm.i18n,
      "title": "Emoji",
      "set": "apple"
    },
    on: {
      "click": _vm.addEmoji
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 text-muted text-right"
  }, [_c('small', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Para usar "), _c('em', [_vm._v("emojis")]), _vm._v(" clique no botão ao lado.")]), _c('br'), _vm._v(" "), _c('small', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_c('strong', [_vm._v("Observação:")]), _vm._v(" no navegador os "), _c('em', [_vm._v("emojis")]), _vm._v(" podem aparecer em forma de [], mas ao enviar aparecerá o "), _c('em', [_vm._v("emoji")]), _vm._v(" selecionado.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "btn-group btn-group-justified",
    attrs: {
      "role": "group"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.emojiPickerVisible = !_vm.emojiPickerVisible
      }
    }
  }, [_c('emoji', {
    attrs: {
      "emoji": "grinning",
      "size": 15
    }
  }), _vm._v("\n\t\t\t\t\t\t\tEmojis\n\t\t\t\t\t\t")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn green-jungle",
    on: {
      "click": _vm.sendNewMessage
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n\t\t\t\t\t\t\tEnviar\n\t\t\t\t\t\t")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn default",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "icon-pencil"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0731ce82","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/inbox/message-new/main.vue
// module id = 1032
// module chunks = 1